// @ts-expect-error Could not find a declaration file
import { wrapReduxAction } from 'AdsUI/lib/ActionWrapper';
import * as AdInteractionData from 'AdsUI/data/AdInteractionData';
export const fetchAllWorkflowsForEntity = (network, adAccountId, entityType, entityIds) => {
  return dispatch => {
    return wrapReduxAction(AdInteractionData.getAllWorkflowsForEntity.bind(null, {
      network,
      adAccountId,
      entityType,
      entityIds
    }), 'AUTOMATION_ALL_WORKFLOWS_FETCH', {
      dispatch,
      returnPromise: true
    });
  };
};